import React from "react"
import { RegistrationFields } from "sharedTypes"
import { Control, UseFormSetValue } from "react-hook-form"
import Field from "./Field"
import Fieldset from "./Fieldset"

type Props = {
  fields: RegistrationFields
  control: Control<any>
  setValue: UseFormSetValue<any>
  syncPhoneWithWhatsappOptIn?: boolean
}

const RegistrationSettingsSwitches = ({
  fields, control, setValue, syncPhoneWithWhatsappOptIn = false,
}: Props) => {
  const generateFields = (fieldType: string) => fields[fieldType].map(
    ({
      name, fieldName, readOnly, requiredLocked, hideRequired,
    }) => (
      <Field
        key={name}
        label={name}
        name={fieldName}
        control={control}
        disabled={readOnly}
        requiredLocked={requiredLocked}
        hideRequired={hideRequired}
        setValue={setValue}
        syncPhoneWithWhatsappOptIn={syncPhoneWithWhatsappOptIn}
      />
    ),
  )

  return (
    <>
      <Fieldset title="Profile Fields">
        {generateFields("personal")}
      </Fieldset>
      <Fieldset title="Address Fields">
        {generateFields("address")}
      </Fieldset>
    </>
  )
}

export default RegistrationSettingsSwitches
